import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const url = new URL(window.location.href);
const action = url.searchParams.get("action");

if (action) {
  localStorage.setItem("action", action);
  url.searchParams.delete("action");

  window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
